
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class NoContent extends Vue {
  @Prop({ default: false }) showLink!: string;

  @Prop({ required: true }) widgetName!: string;
}
